import { SetRoutes } from 'components';
import routes from './routes';

const PresentNotificationsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default PresentNotificationsPages;
